import {
  Box,
  Badge,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  useDisclosure,
} from "@chakra-ui/react";
import NotificationList from "../common/NotificationList";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useNavigate } from "react-router-dom";
import { useEffect, useMemo, memo } from "react";
import { GetNotifications } from "../../redux/modules/account";
import { toastrMsg } from "../../utils/toastrMsg";
import Vector from "../../assets/images/Vector1.svg";

const Notifications = () => {
  const { Notifications } = useAppSelector((state) => ({
    Notifications: state.account.Notifications,
  }));
  let navigate = useNavigate();
  let dispatch = useAppDispatch();
  const {
    isOpen: isNotificationOpen,
    onOpen: onNotificationOpen,
    onClose: onNotificationClose,
  } = useDisclosure();

  const handleClick = (referenceNumber: any, type: any, referenceId: any) => {
    onNotificationClose();
    if (type === "Transaction") {
      navigate(`/transactions/transactiondetails/${referenceId}`);
    } else {
      navigate(`/support/my-tickets/${referenceNumber}`);
    }
  };

  useEffect(() => {
    const getNotifications = async () => {
      let res: any = await dispatch(GetNotifications());
      if (res.error) {
        toastrMsg("Error", res.error.message);
      }
    };
    getNotifications();
  }, [dispatch]);

  const memoizedNotifications = useMemo(() => {
    return Notifications?.map((item: any) => ({
      ...item,
      description: item.description || "New reply on ticket",
    }));
  }, [Notifications]);

  return (
    <>
      {Notifications?.length > 0 && (
        <Box alignItems="center">
          <Popover
            trigger="click"
            placement="bottom-start"
            isOpen={isNotificationOpen}
            onClose={onNotificationClose}
          >
            <PopoverTrigger>
              <Badge
                cursor="pointer"
                position="relative"
                bg="#fff"
                width="30px"
                marginRight="10px"
                borderRadius="5px"
                onClick={onNotificationOpen}
              >
                <img src={Vector} alt="Notifications" />
                <span className="notification-count">
                  {Notifications?.length}
                </span>
              </Badge>
            </PopoverTrigger>
            {isNotificationOpen && (
              <PopoverContent
                minWidth="340px"
                maxW="340px"
                zIndex="999999"
                bg="white"
                _focus={{ boxShadow: "none" }}
                boxShadow="xl"
                borderRadius="lg"
                overflow="hidden"
              >
                <PopoverBody padding="0px" boxShadow="none">
                  <NotificationList
                    notifications={memoizedNotifications}
                    onItemClick={handleClick}
                  />
                </PopoverBody>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      )}
    </>
  );
};

export default memo(Notifications);
